import React from 'react'
import { Alert } from 'react-bootstrap'
import { Container } from 'react-bootstrap'
import { PAGE_NOT_FOUND_MESSAGE } from 'application/constants/messages'
import * as E from './notFoundPageElements'
import globals from 'application/constants/globals'

const NotFoundPage = () => (
  <>
    {globals.isBrandMX && <E.MaxxiaTriangleDiv />}
    {globals.isBrandRS && <E.RemServTriangleDiv />}
    <Container className="notfound-container p-5 mb-5 bg-white shadow-sm">
      <Alert variant="danger">
        <>{PAGE_NOT_FOUND_MESSAGE}</>
      </Alert>
    </Container>
  </>
)

export default NotFoundPage
